"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { viewerMode, type PaletteMode } from "@/lib/theme-palette";
export function useViewerMode() {
  const $ = _c(2);
  const [mode, setMode] = useState("dark");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const update = () => setMode(viewerMode());
      update();
      const obs = new MutationObserver(update);
      obs.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["data-theme"]
      });
      return () => obs.disconnect();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return mode;
}